
import { FeedbackConstant } from "./FeedbackConstant";

const FeedbackAction = {};

FeedbackAction.getFeedbackData = ({status,from_date,to_date,limit,page,search_term}) => {
  return {
    type: FeedbackConstant.FEEDBACK_SAGA,
    payload: {
      status:status,
        to_date:to_date,
        from_date:from_date,
        search_term:search_term,
        limit:limit,
        page:page
    }
}
  
 
  };


export { FeedbackAction };